module.exports = "../dist/frontend/icons/ui/categoryCard.svg?7d5c0ef99bc9238a48deaff8c9b76caa";